module.exports = __webpack_public_path__ + "img/gluten_free.ab7a5547.svg";